<template>
  <b-modal
    :id="'modal-survey'+boxid"
    :no-close-on-backdrop="true"
    :no-close-on-esc="appealInProgress"
    :hide-header-close="appealInProgress"
    :title="$t('Survey Detail')"
    :ok-only="true"
    :ok-title="$t('Close')"
    :size="appealExists ? 'xl' : 'lg'"
    :hide-footer="true"
    @hide="handleHide"
    @ok="close"
    @close="close"
  >

    <survey-viewer
      ref="surveyViewer"
      :projectid="projectId"
      :orjref="orjRef"
      :appeal="appeal"
      :appeal-management="appealManagement"
      @appealExists="setAppealExists"
      @appeal-loading="appealInProgress = $event"
      @reload="$emit('reload')"
    />

    <div
      class="modal-footer d-flex justify-content-between"
      style="padding-left:0;padding-right:0;margin-top:15px;"
    >
      <span>
        <b-button
          class="mr-1"
          variant="success"
          @click="exportToPdf"
        >
          {{ $t('Export to PDF') }}
        </b-button>
        <b-button
          v-if="approvalButton"
          variant="success"
          @click="$emit('approved',{projectId, orjRef})"
        >
          {{ $t('Approve') }}
        </b-button>
        <b-button
          v-if="approvalButton"
          class="ml-1"
          variant="danger"
          @click="$emit('notapproved',{projectId, orjRef})"
        >
          {{ $t('Disapprove') }}
        </b-button>
      </span>
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button
        variant="primary"
        :disabled="appealInProgress"
        @click="close()"
      >
        {{ $t('Close') }}
      </b-button>

    </div>

  </b-modal>
</template>

<script>
import {
  BModal, VBModal, BButton,
} from 'bootstrap-vue'
import SurveyViewer from './SurveyViewer.vue'

export default {
  components: {
    BModal,
    SurveyViewer,
    BButton,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    boxid: {
      type: Number,
      required: true,
    },
    approvalButton: {
      type: Boolean,
      default: false,
    },
    appeal: {
      type: Boolean,
      default: false,
    },
    appealManagement: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      appealExists: false,
      surveyData: null,
      projectId: null,
      orjRef: null,
      appealInProgress: false,
    }
  },
  methods: {
    handleHide(event) {
      if (this.appealInProgress) {
        event.preventDefault()
      }
    },
    exportToPdf() {
      this.$refs.surveyViewer.exportToPDF()
    },
    setAppealExists() {
      this.appealExists = true
    },
    loadSurveyData(projectId, orjRef) {
      this.appealInProgress = false
      this.$bvModal.show(`modal-survey${this.boxid}`)
      this.projectId = projectId
      this.orjRef = orjRef
    },
    close() {
      this.$bvModal.hide(`modal-survey${this.boxid}`)
    },
  },
}
</script>
